import { Box, LssProp } from '@lucidhq/lucidium';
import { memo, ReactNode } from 'react';

import {
  centerLss,
  fullLss,
  largeLss,
  layoutContainerLss,
  mediumLss,
  removePaddingsLss,
  smallLss,
} from './styles';

export interface LayoutProps {
  center?: boolean;
  size?: 'full' | 'large' | 'small' | 'medium';
  children: ReactNode;
  removePaddings?: boolean;
  lss?: LssProp;
}

export const Layout = memo(
  ({
    center = false,
    size = 'large',
    children,
    removePaddings = false,
    lss = {},
  }: LayoutProps) => {
    const sizeMap = {
      medium: mediumLss,
      small: smallLss,
      large: largeLss,
      full: fullLss,
    };

    return (
      <Box
        lss={{
          ...layoutContainerLss,
          ...sizeMap[size],
          ...(center ? centerLss : {}),
          ...(removePaddings ? removePaddingsLss : {}),
          ...lss,
        }}
      >
        {children}
      </Box>
    );
  }
);

Layout.displayName = 'Layout';
